<script>
import RuleFormGroup from '@/components/requests/vmware/RuleFormGroup.vue'
import { TEMPLATE_OPTIONS } from '@/components/requests/vmware/vmware-vm.config'
import { otherOsRules } from '@/components/requests/vmware/vmware-vm.rules'

export default {
  name: 'TemplateSelection',
  components: { RuleFormGroup },
  props: {
    value: { type: Object, default: null }, // gewähltes Template-Objekt
    otherOs: { type: String, default: '' },
    field_enumeration_index: { type: Number, required: true },
  },
  data() {
    return { template_options: TEMPLATE_OPTIONS, other_os_valid: false }
  },
  computed: {
    is_other() {
      return this.value?.os === 'Other'
    },
    other_os_rules() {
      return otherOsRules(this.otherOs, this.$t.bind(this))
    },
    valid() {
      if (this.value === null) return false
      return this.is_other ? this.other_os_valid : true
    },
  },
  watch: {
    valid: {
      immediate: true,
      handler(v) { this.$emit('validity-change', v) },
    },
  },
}
</script>

<template>
  <div>
    <b-form-group :label="$t(`global.enumeration.${field_enumeration_index}`, { msg: $t('components.requests.vmware.os_template') })">
      <b-form-select :value="value" @input="$emit('input', $event)">
        <template #first>
          <b-form-select-option :value="null" disabled>{{ $t('system.please_select') }}</b-form-select-option>
        </template>
        <b-form-select-option v-for="option in template_options" :key="option.name" :value="option">
          {{ option.name }}
        </b-form-select-option>
      </b-form-select>
    </b-form-group>

    <RuleFormGroup v-if="is_other"
                   :value="otherOs"
                   :label="$t('components.requests.vmware.other_os.label')"
                   :rules="other_os_rules"
                   @input="$emit('update:otherOs', $event)"
                   @validity-change="other_os_valid = $event" />
  </div>
</template>
